<template>
  <div class="text-row hidden lg:flex">
    <div class="bg-table rounded divide-y mb-12 mr-12 w-full">
      <RouterLink v-for="event of eventsStore.upcoming" :to="toEvent(event)" class="px-4 w-full flex items-center">
        <div class="w-2/5 font-medium p-2">
          {{ event.event_name }}
        </div>
        <div class="font-medium p-3 px-4 w-2/5">
          <div class="flex text-focus text-base px-4">
            <span class="">
              {{ event.venue_name }},
              {{ event.city }}
            </span>
          </div>
          <div class="flex text-focus text-base px-4">
            <span class="truncate">{{ formatEventDates(event) }}</span>
          </div>
        </div>
        <div class="flex-auto flex justify-end pr-3 text-center">
          <!-- todo: commented because of issue https://gitlab.xs2event.com/webapps/xs2event-portal-v2/-/issues/163 , uncomment if prices are correct -->

          <!--          <span class="rounded bg-primary-color px-3 py-1 text-septenary font-semibold"-->
          <!--            v-if="event.min_ticket_price_eur">&euro;{{ event.min_ticket_price_eur / 100 | 0 }}</span>-->
          <!--          <span class="rounded bg-primary-color px-3 py-1 text-septenary font-semibold"-->
          <!--            v-else-if="event.cheapest_ticket">&euro;{{ -event.cheapest_ticket / 100 | 0 }}</span>-->
          <!--          <span class="rounded bg-neutral-300 text-septenary px-3 py-1 text-septenary font-semibold min-w-80" v-else>{{ $t('N / A')-->
          <!--          }}</span>-->

          <div class="rounded bg-primary text-btn-forecolor px-3 py-1 cursor-pointer">
            <span>{{ $t("Tickets") }}</span>
          </div>
        </div>
        <div class="w-auto">
          <ChevronRightIcon class="h-5 text-secondary" />
        </div>
      </RouterLink>
    </div>
  </div>

  <div class="text-foreground flex flex-col mt-4 lg:hidden w-full">
    <div class="overflow-hidden">
      <ul role="list" class="divide-y bg-alternate-background alternate border-0 rounded-xl overflow-hidden">
        <li v-for="event of eventsStore.upcoming" :key="event.id" class="border-none p-2 pt-2 pb-2">
          <RouterLink :to="toEvent(event)" class="w-full flex items-center p-0 m-0">
            <div class="flex flex-col p-2 flex-grow">
              <h4 class="text-sm tracking-tight text-link-color">{{ event.tournament_name }}</h4>
              <h5 class="text-lg font-bold tracking-tight text-link-color">{{ event.event_name }}</h5>
              <p class="font-normal text-sm text-gray-400 dark:text-link-color">
                {{ event.venue_name }}, {{ event.city }}
              </p>
            </div>
            <div class="flex flex-col shrink-0 text-neutral-800">
              <div
                class="flex flex-col min-w-32 min-h-70 items-center justify-center p-3 rounded-md text-sm font-bold uppercase m-5 bg-search text-search-forecolor">
                <span class="flex date whitespace-nowrap text-sm">{{ formatEventDates(event) }}</span>
              </div>
              <div class="flex flex-col justify-center items-center p-2 text-link-color">
                <u class="text-sm">{{ $t("Book tickets") }}</u>
              </div>
            </div>
          </RouterLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { useEventsStore } from "@/store/events.js";
import { formatDate, formatDates, formatTime } from "@/helpers/format.js";
import { ChevronRightIcon } from "@heroicons/vue/24/outline";
import { toEvent } from "@/components/event";

const eventsStore = useEventsStore();
// eventsStore.fetchUpcoming()

const formatEventDates = ({ date_start, date_stop }) => {
  const date = formatDate(date_start);
  const time = formatTime(date_start);
  if (date !== formatDate(date_stop)) {
    return formatDates(date_start, date_stop);
  } else if (time) {
    return date + ", " + time;
  } else {
    return date;
  }
};
</script>
